// Centralized data-testid keys.
export const TEST_IDS = {
  // Auth
  loginEmailInput: "login-email-input",
  loginPasswordInput: "login-password-input",
  loginSubmitBtn: "login-submit-btn",
  loginErrorMsg: "login-error-msg",
  loginTab: "login-tab",
  registerTab: "register-tab",
  registerNameInput: "register-name-input",
  registerOrgInput: "register-org-input",
  registerSizeSelect: "register-size-select",
  registerSubmitBtn: "register-submit-btn",
  logoutBtn: "logout-btn",
  // Shell
  shellSidebar: "shell-sidebar",
  navDashboard: "nav-dashboard",
  navMeetings: "nav-meetings",
  navTasks: "nav-tasks",
  navDecisions: "nav-decisions",
  navSettings: "nav-settings",
  navAdminUsers: "nav-admin-users",
  navBilling: "nav-billing",
  navPricing: "nav-pricing",
  navAdminBilling: "nav-admin-billing",
  // Dashboard
  dashboardRoot: "dashboard-root",
  kpiTotalMeetings: "kpi-total-meetings",
  kpiOpenTasks: "kpi-open-tasks",
  kpiOverdueTasks: "kpi-overdue-tasks",
  kpiCompletedTasks: "kpi-completed-tasks",
  kpiPendingTranscription: "kpi-pending-transcription",
  kpiDecisionsTaken: "kpi-decisions-taken",
  // Meetings
  meetingsRoot: "meetings-root",
  createMeetingBtn: "create-meeting-btn",
  meetingTitleInput: "meeting-title-input",
  meetingDateInput: "meeting-date-input",
  meetingStartTimeInput: "meeting-start-time-input",
  meetingEndTimeInput: "meeting-end-time-input",
  meetingDescriptionInput: "meeting-description-input",
  meetingAgendaInput: "meeting-agenda-input",
  meetingParticipantInput: "meeting-participant-input",
  meetingSaveBtn: "meeting-save-btn",
  meetingRow: "meeting-row",
  meetingOpenBtn: "meeting-open-btn",
  // Meeting detail
  meetingTitle: "meeting-detail-title",
  startMeetingBtn: "start-meeting-btn",
  endMeetingBtn: "end-meeting-btn",
  // Recording
  recordStartBtn: "record-start-btn",
  recordStopBtn: "record-stop-btn",
  recordPauseBtn: "record-pause-btn",
  recordingTimer: "recording-timer",
  consentCheckbox: "consent-checkbox",
  uploadRecordingBtn: "upload-recording-btn",
  // Tabs
  tabOverview: "tab-overview",
  tabRecording: "tab-recording",
  tabTranscript: "tab-transcript",
  tabAiMinutes: "tab-ai-minutes",
  tabTasks: "tab-tasks",
  tabDecisions: "tab-decisions",
  // Tasks
  tasksRoot: "tasks-root",
  taskRow: "task-row",
  taskStatusSelect: "task-status-select",
  createTaskBtn: "create-task-btn",
  // Decisions
  decisionsRoot: "decisions-root",
};
